export const POSITION_CITIES = {
    LUTSK: 'Lutsk',
    LVIV: 'Lviv',
    REMOTE: 'Remote',
}


// WEBPACK FOOTER //
// ./src/constants.js